@reference "tailwindcss";

/* Target MUI components inside the filter builder using global selectors */
.filterBuilder :global(.MuiOutlinedInput-root) {
  @apply text-sm;
}

.filterBuilder :global(.MuiInputBase-root) {
  @apply px-1 py-0.5;
}

.filterBuilder :global(.MuiInputBase-input) {
  @apply px-1 py-0.5;
}

.filterBuilder :global(.MuiAutocomplete-tag) {
  @apply m-0;
}

/* DatePicker specific styles */
.filterBuilder :global(.MuiInputBase-root) {
  @apply px-1 py-0.5;
}

.filterBuilder :global(.MuiInputBase-input) {
  @apply px-1 py-0.5;
}

.filterBuilder :global(.MuiInputAdornment-root .MuiButtonBase-root) {
  @apply p-1;
}

.filterBuilder :global(.MuiInputAdornment-root .MuiSvgIcon-root) {
  font-size: 1rem !important;
}

.filterBuilder :global(.MuiAutocomplete-endAdornment) {
  right: 2px !important;
}

/* Date picker classes */
.filterBuilder :global(.mui-datepicker .MuiInputAdornment-positionEnd) {
  @apply pr-3;
}

.filterBuilder :global(.mui-datepicker .MuiInputAdornment-positionEnd) {
  @apply ml-0 w-10;
}

.filterBuilder :global(.MuiAutocomplete-tag) {
  @apply ml-1;
}

.filterBuilder :global(.dropdown-select-button) {
  @apply px-1 py-0.5 pl-2;
  color: black;
}

:global(.filterBuilder.MuiAutocomplete-popper .MuiAutocomplete-listbox) {
  @apply text-sm;
}

.filterBuilder :global(.MuiInputBase-adornedEnd) {
  @apply pr-7;
}

.filterBuilder :global(.mui-datepicker .MuiInputBase-adornedEnd) {
  @apply pr-0;
}

.filterBuilder :global(.MuiPickersSectionList-root) {
  @apply p-0;
}
